let baseUrl = process.env.REACT_APP_BACKEND_URL;
let baseUrlFiles = process.env.REACT_APP_BACKEND_URL_FILES;
let gaCode = process.env.REACT_APP_ANALYTICS_CODE;

const stage = process.env.REACT_APP_STAGE;
const bugsnagApiKey = process.env.REACT_APP_BUGSNAG_API_KEY || "undefined";
const azureClientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const azureTenantId = process.env.REACT_APP_AZURE_TENANT_ID;

const documentsPilotUsers = [
  "viktoria.pettersson@ludvig.se",
  "ingegerd.brannstrom@ludvig.se",
  "emma.uddenstig@ludvig.se",
  "viktor.jakovlev@ludvig.se",
  "martin.simonovski@ludvig.se",
  "ivana.beshlikj@ludvig.se",
  "stojan.peshov@ludvig.se",
  "ivan.hristovski@ludvig.se",
  "natasha.kulevanova@ludvig.se",
  "m@noonday.se"
];

if (!baseUrl) {
  gaCode = "UA-92433924-1";
  baseUrl = "https://mittkontor-api-test.ludvig.se/";
}

if (!baseUrlFiles) {
  baseUrlFiles = "https://mittkontor-api-files-test.ludvig.se/";
}

const appUrl = window.location.origin;

const AppConfig = {
  stage,
  bugsnagApiKey,
  appUrl,
  azureClientId,
  azureTenantId,
  documentsPilotUsers,
  analytics: {
    code: gaCode
  },
  internalRoutes: {
    archive: (id) => `archive/${encodeURIComponent(id)}`,
    delivery: "/delivery"
  },
  api: {
    documents: {
      get: (customerId, params) =>
        `${baseUrl}skickaDocuments/${customerId}?${params}`,
      count: (customerId) => `${baseUrl}skickaDocuments/${customerId}/counts`
    },
    files: {
      get: (customerId) => `${baseUrl}files/${customerId}/latestUnhandled`,
      summary: () => `${baseUrl}files/stats/summary`
    },
    messages: {
      get: (customerId) =>
        `${baseUrl}messages/customer/${customerId}/latestUnreadThreads`,
      summary: () => `${baseUrl}messages/stats/summary`
    },
    dashboard: {
      get: (customerId) => `${baseUrl}dashboard/${customerId}`
    },
    sysMessageExternal: {
      get: `${baseUrl}sysMessage`,
      put: `${baseUrl}admin/sysMessage`
    },
    loginMethod: {
      post: `${baseUrl}user/loginMethod`
    },
    notifications: {
      systemMessage: `${baseUrl}admin/sysNotification`,
      deleteSystemMessage: (notificationId) =>
        `${baseUrl}admin/sysNotification/${encodeURIComponent(notificationId)}`
    },
    inventory: {
      articleRegister: {
        get: `${baseUrl}inventory/article_register`
      },
      inventories: {
        get: (customerId) =>
          `${baseUrl}inventory/customers/${customerId}/inventories`
      },
      inventory: {
        create: (customerId) =>
          `${baseUrl}inventory/customers/${customerId}/inventories`,
        createPdf: (customerId, inventoryId) =>
          `${baseUrl}inventory/customers/${customerId}/inventories/${inventoryId}/pdf`,
        get: (customerId, inventoryId) =>
          `${baseUrl}inventory/customers/${customerId}/inventories/${inventoryId}`,
        update: (customerId, inventoryId) =>
          `${baseUrl}inventory/customers/${customerId}/inventories/${inventoryId}`
      }
    },
    fiscalyear: {
      get: (customerId) => `${baseUrl}fiscalyear/${customerId}`
    },
    invoices: {
      offices: {
        get: `${baseUrl}invoice-review/offices`
      },
      assignmentManager: {
        getAssignmentManagers: (officeName) =>
          `${baseUrl}invoice-review/offices/listUA?office=${officeName}`,
        getCommitments: (assignmentManagerId) =>
          `${baseUrl}invoice-review/offices/readyForUA?uppdragsAnsvarig=${assignmentManagerId}`
      },
      resultStatistics: {
        get: (officeName) =>
          `${baseUrl}invoice-review/offices/resultStatistics?office=${officeName}`
      }
    },
    volumeAnalysis: {
      get: (customerId) => `${baseUrl}volume-analysis/${customerId}`
    },
    status: {
      get: (id) => `${baseUrl}poll/${encodeURIComponent(id)}`
    },
    user: {
      validateToken: (token) => `${baseUrl}validate/${token}`,
      isTokenValid: (token) =>
        `${baseUrl}user/externalUserLogin/istokenvalid?resetPasswordToken=${token}`,
      login: `${baseUrl}user/externalUserLogin/login`,
      internalUserLogin: `${baseUrl}user/internalUserLogin`,
      onetimeLogin: `${baseUrl}user/externalUserLogin/onetime-login`,
      generateOnetimeLogin: `${baseUrl}user/externalUserLogin/generate-onetime-login`,
      adminUser: {
        editExternal: `${baseUrl}admin/updateExternalUser`
      },
      externalUsers: {
        put: () =>
          `${baseUrl}user/externalUserLogin/upsertExternalUsersForCustomer`
      },
      find: `${baseUrl}user/externalUserLogin/users/external`,
      internalUsers: `${baseUrl}users/internal/`,
      customers: `${baseUrl}user/customers`,
      search: `${baseUrl}customers/search`,
      create: `${baseUrl}user/`,
      get: `${baseUrl}user/`,
      activation: `${baseUrl}user/activatepassword`,
      setNewPassword: `${baseUrl}user/setnewpassword`,
      setPassword: `${baseUrl}user/externalUserLogin/setpassword`,
      activateUser: `${baseUrl}user/externalUserLogin/activateuser`,
      resetPassword: `${baseUrl}user/externalUserLogin/resetpassword`,
      notifications: `${baseUrl}notifications`,
      notificationRead: (id) =>
        `${baseUrl}notification/${encodeURIComponent(id)}/read`,
      notificationAccepted: (id) =>
        `${baseUrl}notification/${encodeURIComponent(id)}/accepted`,
      notificationRejected: (id) =>
        `${baseUrl}notification/${encodeURIComponent(id)}/rejected`,
      addNewExternalUserToCustomer: (customerId) =>
        `${baseUrl}user/externalUserLogin/addExternalUser/customer/${customerId}`
    },
    customer: {
      get: (id) => `${baseUrl}user/customers/${id}`,
      save: `${baseUrl}user/customers/`,
      threads: {
        get: `${baseUrl}messages/customer/`
      },
      thread: {
        get: `${baseUrl}messages/customer/`,
        put: (customerId, threadId) =>
          `${baseUrl}messages/customer/${customerId}/thread/${encodeURIComponent(
            threadId
          )}`
      },
      addToCustomer: (customerId) => `${baseUrl}customer/${customerId}/add`,
      findUnassinged: `${baseUrl}customers/unassigned/search`,
      findAllCustomers: `${baseUrl}user/customers/searchall`,
      statistics: `${baseUrl}admin/customers/statistics`,
      licenses: `${baseUrl}admin/report/integrationmodules`,
      // TODO: Obsolete?
      close: (customerId) => `${baseUrl}customer/${customerId}/close`,
      getPnlReportForCustomer: (customerId, year, month) =>
        `${baseUrl}pnlshort/${customerId}/${year}/${month}`
    },
    message: {
      del: ({ customerId, messageId, threadId }) =>
        `${baseUrl}messages/customer/${customerId}/thread/${encodeURIComponent(
          threadId
        )}/message/${encodeURIComponent(messageId)}`,
      post: `${baseUrl}messages/`,
      sentMessage: (customerId) => `${baseUrl}messages/sent/${customerId}`
    },
    archive: {
      download: (customerId, fileId) =>
        `${baseUrlFiles}archive/${customerId}/${encodeURIComponent(fileId)}`,
      moveInArchive: (customerId) => `${baseUrl}archive/move/${customerId}`,
      uploadToArchive: (customerId) => `${baseUrlFiles}archive/${customerId}`,
      getArchive: (customerId) => `${baseUrl}archive/${customerId}/folders`,
      getArchiveFolderFiles: (customerId, folderId) =>
        `${baseUrl}archive/${customerId}/folder/${encodeURIComponent(
          folderId
        )}`,
      markAsDeleted: (customerId, itemId) =>
        `${baseUrl}archive/delete/${customerId}/${encodeURIComponent(itemId)}`,
      restoreFile: (customerId, itemId) =>
        `${baseUrl}archive/restore/${customerId}/${encodeURIComponent(itemId)}`,
      deleteFile: (customerId, itemId) =>
        `${baseUrl}archive/${customerId}/${encodeURIComponent(itemId)}`
    },
    file: {
      moveToArchive: (customerId, fileId) =>
        `${baseUrl}files/${customerId}/move/${fileId}`,
      base: `${baseUrl}files/`,
      get: `${baseUrl}files/`,
      post: (customerId) => `${baseUrlFiles}files/${customerId}`,
      postV2: (customerId) => `${baseUrlFiles}files/v2/${customerId}`,
      setHandled: () => `${baseUrl}files/handle/`,
      download: (customerId, fileId) =>
        `${baseUrlFiles}files/${customerId}/${encodeURIComponent(fileId)}`,
      uploadComplete: (customerId, fileId) =>
        `${baseUrlFiles}files/${customerId}/${fileId}/uploadComplete`,
      updateFileName: (customerId, fileId) =>
        `${baseUrl}files/${customerId}/name/${encodeURIComponent(fileId)}`
    },
    services: {
      getServiceLink: (customerId, serviceName) =>
        `${baseUrl}customer/${customerId}/integration/${serviceName}`
    },
    settings: {
      settings: `${baseUrl}settings`,
      oooMess: `${baseUrl}settings/outofoffice`
    },
    support: {
      get: `${baseUrl}support`
    },
    documentService: {
      get: (customerId) => `${baseUrl}documentService/${customerId}`,
      put: (customerId) => `${baseUrl}documentService/${customerId}`
    },
    banners: {
      getAll: () => `${baseUrl}banner`,
      getOne: (bannerID) => `${baseUrl}banner/${bannerID}`,
      post: () => `${baseUrl}banner`,
      put: (bannerID) => `${baseUrl}banner/${bannerID}`,
      delete: (bannerID) => `${baseUrl}banner/${bannerID}`
    },
    externalUserFiles: {
      deleteFile: (customerId, fileId) =>
        `${baseUrl}archive/external/${customerId}/${fileId}/delete`
    }
  },
  static: {
    inventoryInstructions: `${baseUrl}content/instruktion_inventering`,
    licenseAgreement: `${baseUrl}content/useragreement`
  },
  defaults: {
    pageSize: 20
  }
};

export default AppConfig;
